import PropTypes from 'prop-types';
import React from 'react';

import { Consumer as PageConsumer } from '../../../contexts/PageContext';

import { truncateWithEllipsis } from '../../../utilities/ui_utilities';
import FGBLabel from '../../Elements/FGBLabel/FGBLabel';
import ResponsivePicture from '../../Elements/ResponsivePicture/ResponsivePicture';
import ReactRouterLink from '../../Groups/ReactRouterLink';
import SVGIconWrapper from '../../Icons/SVGIconWrapper/SVGIconWrapper';
import { getMaxHeights, PlayButtonIcon } from './constants';

import './EditorialCard.scss';

const breakpoints = {
    smallTablet: {
        width: 540,
        transforms: {
            quality: 'auto',
            crop: 'limit',
        },
    },
    mobile: {
        width: 340,
        transforms: {
            quality: 'auto',
            crop: 'limit',
        },
    },
};

export default class EditorialCard extends React.PureComponent {
    renderVideoWithOverlay = () => {
        return (
            <div className="video-with-overlay">
                {this.renderImage()}
                <div className="video-overlay">
                    <SVGIconWrapper
                        SVGWrapperCssClass="play-button"
                        SVGCssClass="play-button"
                    >
                        <PlayButtonIcon />
                    </SVGIconWrapper>
                    <div className="heading">Watch</div>
                </div>
            </div>
        );
    };

    renderVideo = () => {
        if (this.props.location === 'SingleContent') {
            return (
                <div
                    className="video"
                    dangerouslySetInnerHTML={{ __html: this.props.embedHtml }}
                />
            );
        }

        return this.renderVideoWithOverlay();
    };

    renderImage = () => {
        const maxHeights = getMaxHeights(this.props.location);

        const image = this.props.image?.src || this.props.image;

        return (
            <div className="card-image-wrapper">
                <ResponsivePicture
                    breakpoints={breakpoints}
                    cloudinaryID={image}
                    alt=""
                    useShine={
                        this.props.subType === 'image' ||
                        this.props.isCommunityLink
                    }
                    maxHeights={maxHeights}
                    lazyLoad={this.props.lazyLoadImages}
                />
            </div>
        );
    };

    renderComment = () => {
        return (
            <div className="created-content-comment">
                {this.props.truncateText
                    ? truncateWithEllipsis(this.props.comment, 400, false)
                    : this.props.comment}
                {this.props.truncateText && (
                    <p className="more-text">More...</p>
                )}
            </div>
        );
    };

    renderEditorialCardBody = () => {
        return (
            <React.Fragment>
                {this.props.comment ? this.renderComment() : null}

                {this.props.subType === 'video' && this.renderVideo()}

                {this.props.image && this.props.subType !== 'video'
                    ? this.renderImage()
                    : null}

                {this.props.wink ? (
                    <FGBLabel>{this.props.wink}</FGBLabel>
                ) : null}

                <div className="content-title-display">
                    {truncateWithEllipsis(
                        this.props.title,
                        this.props.characterLimit
                    )}
                </div>

                {this.props.description && (
                    <div className="content-description-display">
                        {truncateWithEllipsis(this.props.description, 67)}
                    </div>
                )}
            </React.Fragment>
        );
    };

    render() {
        const rel =
            this.props.targetAction === '_blank' ? 'noopener nofollow' : null;
        return (
            <div
                className={`component-Community-EditorialCard ${this.props.className}`}
            >
                <PageConsumer>
                    {({ pageProps }) => {
                        if (
                            this.props.location !== 'groupFeed' ||
                            !pageProps.frontendRouting
                        ) {
                            return (
                                <a
                                    className="main-content-link"
                                    href={this.props.contentUrl}
                                    target={this.props.targetAction}
                                    rel={rel}
                                >
                                    {this.renderEditorialCardBody()}
                                </a>
                            );
                        }

                        return (
                            <ReactRouterLink
                                to={this.props.contentUrl}
                                linkText={this.props.contentUrl}
                                buildFullPath={false}
                            >
                                <div className="main-content-link">
                                    {this.renderEditorialCardBody()}
                                </div>
                            </ReactRouterLink>
                        );
                    }}
                </PageConsumer>
            </div>
        );
    }
}

EditorialCard.propTypes = {
    description: PropTypes.string,
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    wink: PropTypes.string,
    contentUrl: PropTypes.string.isRequired,
    comment: PropTypes.string,
    targetAction: PropTypes.string,
    characterLimit: PropTypes.number,
    className: PropTypes.string,
    location: PropTypes.oneOf([
        'Feed',
        'SingleContent',
        'groupFeed',
        'contributions',
        'masterFeed',
    ]),
    /**
     * string of iframe to be rendered
     */
    embedHtml: PropTypes.string,
    /**
     * string enum of video or url
     */
    subType: PropTypes.oneOf(['video', 'url', 'photo']),
    truncateText: PropTypes.bool,
    isCommunityLink: PropTypes.bool,
    lazyLoadImages: PropTypes.bool,
};

EditorialCard.defaultProps = {
    wink: '',
    comment: '',
    description: '',
    location: 'Feed',
    targetAction: '_self',
    characterLimit: 110,
    className: '',
    embedHtml: '',
    subType: 'url',
    truncateText: false,
    isCommunityLink: false,
    lazyLoadImages: false,
};
